(function () {
  'use strict';

  if (window.theme && window.theme.utils && typeof window.theme.utils.wrap === 'function') {
    var _origWrap = window.theme.utils.wrap;
    if (!_origWrap._ns) {
      window.theme.utils.wrap = function(el, wrapper) {
        if (!el || !el.parentNode) return;
        _origWrap.call(this, el, wrapper);
      };
      window.theme.utils.wrap._ns = true;
    }
  }

  function initNav() {
    var allDetails = Array.from(document.querySelectorAll('.site-nav__details'));
    if (!allDetails.length) return;

    allDetails.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;

      new MutationObserver(function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }).observe(details, { attributes: true, attributeFilter: ['open'] });

      details.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && details.open) {
          details.removeAttribute('open');
          summary.focus();
        }
      });

      summary.addEventListener('keydown', function (e) {
        var li = details.closest('li');
        if (!li) return;
        if (e.key === 'ArrowRight') {
          var next = li.nextElementSibling && li.nextElementSibling.querySelector('summary');
          if (next) { e.preventDefault(); next.focus(); }
        }
        if (e.key === 'ArrowLeft') {
          var prev = li.previousElementSibling && li.previousElementSibling.querySelector('summary');
          if (prev) { e.preventDefault(); prev.focus(); }
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.site-navigation')) {
        allDetails.forEach(function (d) { if (d.open) d.removeAttribute('open'); });
      }
    }, { passive: true });
  }

  function init() { initNav(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
